<script lang="ts">
    import { formatCurrency } from "$src/presentation/core/currencyUtils";
    import { ArrowDown, ArrowUp } from "lucide-svelte";
  
    export let value: number;
  </script>
  
  {#if value > 0}
    <div
      class="flex flex-row justify-center gap-2 items-center border p-1 rounded-full border-green-500 text-green-500"
    >
      <ArrowUp class={"h-3 w-3"} />
      {value} %
    </div>
  {:else if value < 0}
    <div
      class="flex flex-row justify-between gap-2 items-center border p-1 rounded-full border-red-500 text-red-500"
    >
      <ArrowDown class={"h-3 w-3"} />
      {value} %
    </div>
  {:else}
    <div
       class="flex flex-row justify-between gap-2 items-center border p-1 rounded-full border-yellow-500 text-yellow-500"
    >
    {value} %
    </div>
  {/if}
  